import {
    FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
    FIREBASE_GET_LATEST_TASK_FILE_ERROR,
    SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY,
    SYNCHRONOUS_CHANGE_SIBLING_POSITION,
    SYNCHRONOUS_CHANGE_PARENT,
    SYNCHRONOUS_CHANGE_TODO_PRIORITY,
    SYNCHRONOUS_ORDER_SIBLINGS
} from '../../actions/Firebase/getLatestTaskListAction';

import { ADD_COMMENT_SUCCESS, ADD_COMMENT_ERROR } from '../../actions/TodoManipulation/addCommentAction';

import { FIREBASE_ADD_TASK_SUCCESS, FIREBASE_ADD_TASK_ERROR } from '../../actions/TodoManipulation/addTodoToFirebaseAction';

import { FIREBASE_AI_TASKS_SUCCESS, FIREBASE_AI_TASKS_ERROR } from '../../actions/TodoManipulation/aiTasksToFirebaseAction';

import { BULK_EDIT_TASK_SUCCESS, BULK_EDIT_TASK_ERROR } from '../../actions/TodoManipulation/bulkEditAction';

import { CHANGE_COLOR_SUCCESS, CHANGE_COLOR_ERROR } from '../../actions/TodoManipulation/changeColorAction';

import { CHANGE_PARENT_SUCCESS, CHANGE_PARENT_ERROR } from '../../actions/TodoManipulation/changeParentAction';

import { CHANGE_PRIORITY_SUCCESS, CHANGE_PRIORITY_ERROR } from '../../actions/TodoManipulation/changePriorityAction';

import { CHANGE_SIBLING_POSITION_SUCCESS, CHANGE_SIBLING_POSITION_ERROR } from '../../actions/TodoManipulation/changeSiblingPositionAction';

import { CHANGE_TYPE_SUCCESS, CHANGE_TYPE_ERROR } from '../../actions/TodoManipulation/changeTypeAction';

import { DELETE_COMMENT_SUCCESS, DELETE_COMMENT_ERROR } from '../../actions/TodoManipulation/deleteCommentAction';

import { FIREBASE_DELETE_TASK_SUCCESS, FIREBASE_DELETE_TASK_ERROR } from '../../actions/TodoManipulation/deleteTaskFromFirebaseAction';

import { DUPLICATE_TODO_SUCCESS, DUPLICATE_TODO_ERROR } from '../../actions/TodoManipulation/duplicateTodoAction';

import { EDIT_COMMENT_SUCCESS, EDIT_COMMENT_ERROR } from '../../actions/TodoManipulation/editCommentAction';

import { FIREBASE_EDIT_TASK_SUCCESS, FIREBASE_EDIT_TASK_ERROR } from '../../actions/TodoManipulation/editTaskInFirebaseAction';

import { IMPORT_MINDMAP_SUCCESS, IMPORT_MINDMAP_ERROR } from '../../actions/TodoManipulation/importMindmapAction';

import { ORDER_SIBLINGS_SUCCESS, ORDER_SIBLINGS_ERROR } from '../../actions/TodoManipulation/orderSiblingsAction';

import { bulkEditTaskInFirebase } from "../../actions/TodoManipulation/bulkEditAction";

import { REDO_SUCCESS, REDO_ERROR } from '../../actions/TodoManipulation/redoAction';

import { UNDO_SUCCESS, UNDO_ERROR } from '../../actions/TodoManipulation/undoAction';




import * as idb from '../../../functions/databaseService/indexedDB';
import { findBy$IdInTreeList, findByIdInTreeList, findRootProjects } from '../../../utils/tree';
import { changePrioritySynchronously as changePrioritySynchronouslyImported } from '../../../functions/dragFunctions/changePrioritySynchronously';
import { changeSiblingPositionSynchronously as changeSiblingPositionSynchronouslyImported } from '../../../functions/dragFunctions/changeSiblingPositionSynchronously';
import _ from 'lodash';
import { createSlice } from "@reduxjs/toolkit";
import { changeGlobalPriority, changeParent, changeSiblingPosition, changeTodoPriority, orderSiblings } from '../../../functions/dragFunctions/synchronousToDoManipulation';


const initialState = {
    data: [],
    error: null,
    canUndo: false,
    canRedo: false,
};

const combinedReducer = (state = initialState, action) => {
    switch (action.type) {
      
        // taskList reducer 
        case FIREBASE_GET_LATEST_TASK_FILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case FIREBASE_GET_LATEST_TASK_FILE_ERROR:
            //const error= action.payload;
            //if (error.response.status === 401) {
            //    console.log("Unauthorized access");
            //    window.location.href = `${import.meta.env.VITE_PUBLIC_DOMAIN}/Welcome`;

            //}
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY:
            return {
                ...state,
                data: changeGlobalPriority(state.data, action.payload.orderedChildren)
            };
        case SYNCHRONOUS_CHANGE_PARENT:
            return {
                ...state,
                data: changeParent(state.data, action.payload.movedTaskId, action.payload.destinationProjectId,
                    action.payload.sourceProjectId, action.payload.nearestTaskId, action.payload.destinationIndex)
            };


        case SYNCHRONOUS_CHANGE_SIBLING_POSITION:
            return {
                ...state,
                data: changeSiblingPosition(state.data, action.payload.movedProjectId, action.payload.newIndex)
            };
        case SYNCHRONOUS_CHANGE_TODO_PRIORITY:
            return {
                ...state,
                data: changeTodoPriority(state.data, action.payload.taskId, action.payload.newPriority)
            };
        case SYNCHRONOUS_ORDER_SIBLINGS:
            return {
                ...state,
                data: orderSiblings(state.data, action.payload.parentId, action.payload.orderedIds)
            };

        //TODO MANIPULATION

        //Add Comment Reducer
        case ADD_COMMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case ADD_COMMENT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Add Todo To Firebase Reducer
        case FIREBASE_ADD_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case FIREBASE_ADD_TASK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //AI Tasks to Firebase Reducer
        case FIREBASE_AI_TASKS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case FIREBASE_AI_TASKS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Bulk Edit Reducer
        case BULK_EDIT_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case BULK_EDIT_TASK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Change Colour Reducer
        case CHANGE_COLOR_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case CHANGE_COLOR_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Change Parent Reducer
        case CHANGE_PARENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case CHANGE_PARENT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Change Priority Reducer
        case CHANGE_PRIORITY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case CHANGE_PRIORITY_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Change Sibliing Position Reducer
        case CHANGE_SIBLING_POSITION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case CHANGE_SIBLING_POSITION_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Change Type Reducer
        case CHANGE_TYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case CHANGE_TYPE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Delete Comment Reducer
        case DELETE_COMMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case DELETE_COMMENT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Delete Task From Firebase Reducer
        case FIREBASE_DELETE_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case FIREBASE_DELETE_TASK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Duplicate Todo Reducer
        case DUPLICATE_TODO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case DUPLICATE_TODO_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Edit Comment Reducer
        case EDIT_COMMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case EDIT_COMMENT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Edit Task in Firebase Reducer
        case FIREBASE_EDIT_TASK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case FIREBASE_EDIT_TASK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Import Reducer
        case IMPORT_MINDMAP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case IMPORT_MINDMAP_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Order Siblings Reducer
        case ORDER_SIBLINGS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case ORDER_SIBLINGS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Project Reducer
        //TODO - Convert Create Slice

        //Redo Reducer
        case REDO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case REDO_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        //Todo Manipulation Reducer
        //TODO - Convert Create Slice

        //Undo Reducer
        case UNDO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.tasks || action.payload,
                canUndo: action.payload.canUndo !== undefined ? action.payload.canUndo : state.canUndo,
                canRedo: action.payload.canRedo !== undefined ? action.payload.canRedo : state.canRedo,
            };
        case UNDO_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        default:
            return state;
    }

};

export default combinedReducer;



